import { Injectable } from '@angular/core';
import { ApiRoutes } from 'src/app/config/api-routes';
import { HttpClient } from '@angular/common/http';
import { LoginSuccessResponse } from '../shared/model/login-success-response';
import {DeleteAccountRequest} from "./deletion/delete-account-request";

@Injectable()
export class AccountService {

  constructor(private httpClient: HttpClient, private config: ApiRoutes) {
  }

  public confirmAccount(confirmationCode: string, password: string, privacyConsentAccepted: boolean | null = null){
    return this.httpClient.post<LoginSuccessResponse>(this.config.CONFIRM_ACCOUNT, {confirmationCode, password, privacyConsentAccepted});
  }

  public confirmAccountDeletion(deletionCode: string, loginId: number) {
    return this.httpClient.post<void>(
        this.config.CONFIRM_ACCOUNT_DELETION,
        {deletionCode, loginId} as DeleteAccountRequest,
    );
  }

}
